export const RECEIVED = "Received";
export const IMPLEMENTED = "Implemented";
export const REJECTED = "Rejected";
export const REQUEST_FOR_INFORMATION = "Request";
export const CLOSED = "Closed";
export const COMMENT_FROM_CUSTOMER = "CommentFromCustomer";
export const COMMENT_TO_CUSTOMER = "CommentToCustomer";


// WEBPACK FOOTER //
// ./src/incidents/comments/commentResolutionProposalActionTypes.js